module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('article', [(_vm.loading.state) ? _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "loading__box"
  }, _vm._l((12), function(n) {
    return _c('div', {
      staticClass: "loading__circle"
    })
  }))]) : (_vm.searchResultsList.length != 0) ? _c('ul', _vm._l((_vm.searchResultsList), function(result) {
    return _c('li', {
      staticClass: "item",
      attrs: {
        "id": result.id
      }
    }, [_c('div', {
      staticClass: "item__header"
    }, [_c('h3', {
      staticClass: "item__header--title"
    }, [_c('i', {
      staticClass: "item__header--icon onp-newspaper"
    }), _vm._v(" " + _vm._s(result.newspaper_title))])]), _vm._v(" "), _c('div', {
      staticClass: "item__content"
    }, [_c('div', {
      staticClass: "item__picture"
    }, [_c('figure', {
      staticClass: "item__picture--figure"
    }, [_c('img', {
      staticClass: "item__picture--image",
      attrs: {
        "src": result.thumbnail_url,
        "alt": "Image"
      },
      on: {
        "error": function($event) {
          _vm.brokenImgUrl($event)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "item__infobox"
    }, [_c('div', {
      staticClass: "item__infobox--row"
    }, [_c('div', {
      staticClass: "item__infobox--label"
    }, [_vm._v(_vm._s(_vm.$lang.global.language) + ":")]), _vm._v(" "), _c('div', {
      staticClass: "item__infobox--content"
    }, _vm._l((result.language), function(lang) {
      return _c('span', [_c('strong', [_c('check-lang-code', {
        attrs: {
          "langCode": lang
        }
      })], 1)])
    }))]), _vm._v(" "), (result.subject) ? _c('div', {
      staticClass: "item__infobox--row"
    }, [_c('div', {
      staticClass: "item__infobox--label"
    }, [_vm._v(_vm._s(_vm.$lang.global.subject) + ":")]), _vm._v(" "), _c('div', {
      staticClass: "item__infobox--content"
    }, _vm._l((result.subject), function(subject) {
      return _c('span', [_vm._v(_vm._s(subject))])
    }))]) : _vm._e(), _vm._v(" "), (result.publisher) ? _c('div', {
      staticClass: "item__infobox--row"
    }, [_c('div', {
      staticClass: "item__infobox--label"
    }, [_vm._v(_vm._s(_vm.$lang.global.publisher) + ":")]), _vm._v(" "), _c('div', {
      staticClass: "item__infobox--content"
    }, _vm._l((result.publisher), function(publisher) {
      return _c('span', [_c('strong', [_vm._v(_vm._s(publisher))])])
    }))]) : _vm._e(), _vm._v(" "), (result.place_of_publishing) ? _c('div', {
      staticClass: "item__infobox--row"
    }, [_c('div', {
      staticClass: "item__infobox--label"
    }, [_vm._v(_vm._s(_vm.$lang.global.place_of_publishing) + ":")]), _vm._v(" "), _c('div', {
      staticClass: "item__infobox--content"
    }, _vm._l((result.place_of_publishing), function(place_of_publishing) {
      return _c('span', [_vm._v(_vm._s(place_of_publishing))])
    }))]) : _vm._e(), _vm._v(" "), (result.data_provider) ? _c('div', {
      staticClass: "item__infobox--row"
    }, [_c('div', {
      staticClass: "item__infobox--label"
    }, [_vm._v(_vm._s(_vm.$lang.global.data_provider) + ":")]), _vm._v(" "), _c('div', {
      staticClass: "item__infobox--content"
    }, _vm._l((result.data_provider), function(data_provider) {
      return _c('span', [_vm._v(_vm._s(data_provider))])
    }))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "item__footer"
    }, [_c('div', {
      staticClass: "item__issue-period"
    }, [_vm._v("\n            " + _vm._s(_vm.$lang.global.issue_period) + ": "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(result.date_start, "YYYY")) + " - " + _vm._s(_vm._f("moment")(result.date_end, "YYYY")))])]), _vm._v(" "), _c('div', {
      staticClass: "item__count"
    }, [_vm._v("\n            " + _vm._s(_vm.$lang.global.count) + ": "), _c('strong', {
      directives: [{
        name: "thousand-number",
        rawName: "v-thousand-number",
        value: (result.count),
        expression: "result.count"
      }],
      attrs: {
        "lang": _vm.$lang.language
      }
    }, [_vm._v(_vm._s(result.count))])]), _vm._v(" "), _c('div', {
      staticClass: "item__showFBC"
    }, [_c('a', {
      staticClass: "item__showFBC--link",
      attrs: {
        "target": "_blank",
        "href": _vm.fbcSearchQueryPrefix() + _vm.fbcSearchQueryByTitle(result.newspaper_title)
      }
    }, [_vm._v("\n              " + _vm._s(_vm.$lang.global.show_FBC) + " "), _c('i', {
      staticClass: "item__showFBC--icon onp-openwindow"
    })])])])])
  })) : _c('div', {
    staticClass: "noresults"
  }, [_vm._v("\n      " + _vm._s(_vm.$lang.search.results.no_results) + "\n    ")])]), _vm._v(" "), (_vm.searchResultsList.length != 0) ? _c('div', {
    staticClass: "columns columns__bottom"
  }, [_c('div', {
    staticClass: "column--ipp"
  }, [_c('items-per-page')], 1), _vm._v(" "), _c('div', {
    staticClass: "column column--pagination"
  }, [_c('pagination')], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-385e25c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search/SearchResults.vue
// module id = 334
// module chunks = 1